// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k9-0";
export var fileCarousel = "_k9-2";
export var removeFileButton = "_k9-1";